import { createOngoingGameStore } from '@slot-nx/core'
import { GameResult } from '../model'

export const useOngoingGameStore = createOngoingGameStore<GameResult>()
